import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import LuxPlusMonthCalendarLogoLottieAnimation from './LuxPlusMonthCalendarLogoLottieAnimation.json'
import Lottie from 'components/utils/Lottie'

const Container = styled.div`
  display: inline-grid;
  align-items: end;
  justify-content: stretch;
  overflow: visible;

  &.size-S {
    grid-template: ${rem(48)} / ${rem(48)};
  }
  &.size-M {
    grid-template: ${rem(72)} / ${rem(72)};
  }
`

const Logo = styled(Lottie)`
  min-width: ${rem(48)};
  aspect-ratio: 2/3;
`

interface Props {
  size: 'S' | 'M'
}

function LuxPlusMonthCalendarLogo({ size }: Props) {
  return <Container className={`size-${size}`}>
    <Logo animationData={LuxPlusMonthCalendarLogoLottieAnimation} loop autoplay className={`size-${size}`} />
  </Container>
}

export default LuxPlusMonthCalendarLogo
